import React, { useState } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, message } from 'antd';
import { 
  HomeOutlined, 
  FileTextOutlined, 
  UserOutlined, 
  LoginOutlined, 
  LogoutOutlined,
  EditOutlined,
  MenuOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';

const { Header: AntHeader } = Layout;

const Header = ({ isAuthenticated, user, onLogout }) => {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'home':
        navigate('/');
        break;
      case 'archive':
        navigate('/archive');
        break;
      case 'about':  
        navigate('/about');
        break;
      case 'write':
        navigate('/write');
        break;
      case 'profile':
        navigate('/about');  
        break;
      case 'logout':
        onLogout();
        message.success('已退出登录');
        navigate('/');
        break;
      default:
        break;
    }
    setMobileMenuVisible(false);
  };

  const userMenuItems = [
    {
      key: 'profile',
      label: '个人中心',
      icon: <UserOutlined />
    },
    {
      key: 'write',
      label: '写文章',
      icon: <EditOutlined />
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      danger: true
    }
  ];

  const menuItems = [
    {
      key: 'home',
      label: '首页',
      icon: <HomeOutlined />
    },
    {
      key: 'archive',
      label: '归档',
      icon: <FileTextOutlined />
    },
    {
      key: 'about',  
      label: '我的',
      icon: <UserOutlined />
    }
  ];

  return (
    <AntHeader className="site-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo">
            <span className="logo-text">我的博客</span>
          </Link>
          
          <div className="desktop-menu">
            <Menu
              mode="horizontal"
              items={menuItems}
              onClick={handleMenuClick}
              className="header-menu"
              selectedKeys={[]}
            />
          </div>
        </div>

        <div className="header-right">
          {isAuthenticated ? (
            <>
              <Button 
                type="primary" 
                icon={<EditOutlined />} 
                onClick={() => navigate('/write')}
                className="write-btn"
              >
                写文章
              </Button>
              
              <Dropdown menu={{ items: userMenuItems, onClick: handleMenuClick }}>
                <div className="user-info">
                  <Avatar 
                    size="small" 
                    src={user?.avatar} 
                    icon={<UserOutlined />}
                  />
                  <span className="username">{user?.username}</span>
                </div>
              </Dropdown>
            </>
          ) : (
            <Button 
              type="primary" 
              icon={<LoginOutlined />} 
              onClick={() => navigate('/auth')}
            >
              登录/注册
            </Button>
          )}
          
          <Button 
            type="text" 
            icon={<MenuOutlined />} 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
          />
        </div>

        {mobileMenuVisible && (
          <div className="mobile-menu">
            <Menu
              mode="vertical"
              items={isAuthenticated 
                ? [...menuItems, ...userMenuItems.filter(item => !item.type)] 
                : menuItems
              }
              onClick={handleMenuClick}
            />
          </div>
        )}
      </div>
    </AntHeader>
  );
};

export default Header;